const produto = angular.module('produto', [])

produto.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.produto',
            url: '/:idGuia/produto/:idProduto',
            params: { showGlobalLoading: { dynamic: true, value: true }, idGuia: null },
            component: 'produto.produtoComponent'
        },
        {
            name: 'cliente.produtoModulo',
            url: '/:idGuia/produto/:idProduto/modulo/:idModulo',
            params: { showMenu:false, showGlobalLoading: { dynamic: true, value: true }, idGuia: null },
            component: 'produto.moduloComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);